var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "chat-message mb-4",
      class: _vm.isUser
        ? "chat-message--user d-flex justify-end"
        : "d-flex justify-start"
    },
    [
      _vm.isUser
        ? [
            _c(
              "div",
              { staticClass: "chat-message__usuario" },
              [
                _vm.temAnexos
                  ? _c("ComposerAttachments", {
                      staticClass: "chat-message__anexos",
                      attrs: {
                        "somente-leitura": "",
                        arquivos: _vm.anexosDaMensagem
                      }
                    })
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass:
                      "message-bubble user-bubble ia-texto-corpo pa-2"
                  },
                  [
                    _vm.comandoDaFala
                      ? _c(
                          "div",
                          {
                            staticClass: "chat-message__comando az-gap-xsmall",
                            attrs: { "data-teste": "fala-comando" }
                          },
                          [
                            _c("ComandoChip", {
                              attrs: {
                                "com-fundo": "",
                                rotulo: _vm.comandoDaFala.rotulo
                              }
                            }),
                            _vm.comandoDaFala.argumento
                              ? _c(
                                  "span",
                                  {
                                    attrs: {
                                      "data-teste": "fala-comando-argumento"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.comandoDaFala.argumento) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _c("div", [_vm._v(_vm._s(_vm.content))]),
                    _vm.temAnexosPersistidos
                      ? _c("ComposerAttachments", {
                          staticClass: "chat-message__anexos",
                          attrs: {
                            "somente-leitura": "",
                            arquivos: _vm.itensDeAnexosPersistidos
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm.isAssistant || _vm.isStreaming
        ? [
            _c(
              "div",
              { staticClass: "assistant-content" },
              [
                _vm.mostrarAgenteBadge
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-wrap align-center az-gap-xsmall mb-2"
                      },
                      _vm._l(_vm.badgesDoTurno, function(badge, index) {
                        return _c("AgentBadge", {
                          key: index + "-" + (badge.agentSlug || "sem-agente"),
                          attrs: {
                            hub: badge.hub,
                            "agent-slug": badge.agentSlug,
                            "agent-label": badge.agentLabel || "",
                            motivo: badge.motivo,
                            estado: badge.estado
                          }
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _c(
                  "AssistantBlocks",
                  {
                    attrs: {
                      painel: _vm.painel,
                      plano: _vm.planoDoTurnoAtual,
                      passos: _vm.passosDoRaciocinio,
                      "passo-atual": _vm.passoExibidoDoTurno,
                      "passo-de-trabalho": _vm.passoPrendeATela,
                      "duracao-segundos": _vm.duracaoDoTurno,
                      "rotulo-do-tempo": _vm.rotuloDoTempoDoTurno,
                      auxiliares: _vm.auxiliaresDoRaciocinio,
                      "erro-do-turno": _vm.erroParaALinhaDeRaciocinio,
                      streaming: _vm.trabalhando,
                      "perguntas-ja-no-formulario": _vm.perguntasAoGestor
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "antes-do-texto",
                        fn: function() {
                          return [
                            _c("ChatMessagePlano", {
                              attrs: {
                                itens: _vm.itensPlano,
                                comando: _vm.comandoDoTurno,
                                ativo: _vm.isStreaming,
                                encenavel: _vm.planoEncenavel
                              }
                            }),
                            _c("BuscaWeb", {
                              attrs: { eventos: _vm.eventosDeBusca }
                            }),
                            _c("CodigoExecutado", {
                              attrs: { eventos: _vm.eventosDeCodigo }
                            }),
                            _c("ArquivoGerado", {
                              attrs: { eventos: _vm.eventosDeArquivo }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _c("transition", { attrs: { name: "iv2-parte" } }, [
                      _vm.content
                        ? _c(
                            "div",
                            { staticClass: "ia-message-content" },
                            [
                              _c("AawzMarkdownRender", {
                                attrs: {
                                  source: _vm.conteudoRenderizado,
                                  "allow-html": _vm.persona.permiteHtml,
                                  "no-linkify": !_vm.linkifyAtivo,
                                  postrender: _vm.postrenderExtra
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ],
                  1
                ),
                _vm.partesResolvidas.length
                  ? _c(
                      "transition-group",
                      {
                        staticClass: "d-flex flex-column az-gap mt-2",
                        attrs: {
                          name: "iv2-parte",
                          tag: "div",
                          appear: _vm.cartoesEntramAnimados
                        }
                      },
                      _vm._l(_vm.partesResolvidas, function(parte) {
                        return _c(
                          "div",
                          {
                            key: parte.identidade,
                            staticClass: "iv2-parte",
                            class: { "iv2-parte--validando": parte.validando },
                            attrs: {
                              "data-artefato-id": parte.ancoraDeArtefato
                            }
                          },
                          [
                            _c(
                              parte.componente,
                              _vm._b(
                                {
                                  tag: "component",
                                  attrs: {
                                    state: parte.state,
                                    "tool-call-id": parte.toolCallId,
                                    "id-proposta": parte.idProposta || null,
                                    label: parte.label,
                                    "data-teste": "parte-do-turno",
                                    "data-tool-call-id":
                                      parte.toolCallId || null,
                                    "turno-em-voo": _vm.turnoEmVoo,
                                    "somente-leitura":
                                      parte.somenteLeitura === true,
                                    "etapa-historica": _vm.etapaHistorica,
                                    "resposta-do-cartao": _vm.respostaDoCartao,
                                    "estado-do-run": _vm.estadoDoRun
                                  },
                                  on: {
                                    respond: function($event) {
                                      return _vm.onRespond(parte, $event)
                                    },
                                    avancar: _vm.avancarNaApresentacao,
                                    "open-service": _vm.onOpenService,
                                    ask: _vm.onAsk,
                                    abrir: function($event) {
                                      return _vm.onAbrirArtefato(parte)
                                    },
                                    fechar: _vm.onFecharArtefato
                                  }
                                },
                                "component",
                                parte.props,
                                false
                              )
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm.temEntregas
                  ? _c("GraficoDoTurno", {
                      attrs: {
                        graficos: _vm.graficosDoTurno,
                        "id-conversa": _vm.idConversa
                      }
                    })
                  : _vm._e(),
                _vm.temEntregas
                  ? _c(
                      "div",
                      {
                        staticClass: "mt-3",
                        attrs: { "data-teste": "entregas-do-turno" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "az-text-secondary az-size-12 mb-1" },
                          [_vm._v(" " + _vm._s(_vm.tituloDasEntregas) + " ")]
                        ),
                        _c("ComposerAttachments", {
                          attrs: {
                            "somente-leitura": "",
                            "com-download": "",
                            arquivos: _vm.entregasDoTurno,
                            "baixando-por-chave": _vm.baixandoPorChave
                          },
                          on: { baixar: _vm.baixarEntrega }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.erroDoTurno
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "chat-message-erro-do-turno ia-block-card mt-2",
                        attrs: { "data-teste": "turno-com-erro" }
                      },
                      [
                        _c("CartaoCabecalho", {
                          attrs: {
                            titulo: _vm.textos.tituloErroDoTurno,
                            fita: "",
                            compacto: ""
                          },
                          scopedSlots: _vm._u(
                            [
                              _vm.mostrarTentarDeNovo
                                ? {
                                    key: "meta",
                                    fn: function() {
                                      return [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "ia-block-card__abrir",
                                            attrs: {
                                              type: "button",
                                              disabled: _vm.reenviando,
                                              "data-teste": "tentar-de-novo"
                                            },
                                            on: { click: _vm.tentarDeNovo }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.rotuloTentarDeNovo) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                : null
                            ],
                            null,
                            true
                          )
                        }),
                        _c(
                          "div",
                          { staticClass: "ia-block-card__corpo" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "az-text-primary az-size-14",
                                attrs: { "data-teste": "motivo-do-erro" }
                              },
                              [
                                _vm.saldoEsgotado
                                  ? _c("AawzMarkdownRender", {
                                      attrs: {
                                        source: _vm.textoDoErroDoTurno,
                                        "allow-html": false
                                      }
                                    })
                                  : [_vm._v(_vm._s(_vm.textoDoErroDoTurno))]
                              ],
                              2
                            ),
                            _vm.saldoEsgotado
                              ? [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "az-text-primary az-size-14 az-muted mt-3 mb-0",
                                      attrs: {
                                        "data-teste":
                                          "orientacao-saldo-esgotado"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.copySaldoEsgotado.ORIENTACAO
                                          ) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "BaseButton",
                                    {
                                      staticClass: "mt-3",
                                      attrs: {
                                        primary: "",
                                        "fit-content": "",
                                        "min-width": "auto",
                                        "data-teste": "abrir-creditos"
                                      },
                                      on: { click: _vm.abrirCreditos }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.copySaldoEsgotado.ABRIR_CREDITOS
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.mensagemTruncada
                  ? _c(
                      "output",
                      {
                        staticClass: "chat-message-truncada mt-2 text-caption"
                      },
                      [_vm._v(" " + _vm._s(_vm.textos.avisoTruncada) + " ")]
                    )
                  : _vm._e(),
                _c(
                  "transition",
                  {
                    attrs: {
                      name: "iv2-parte",
                      appear: _vm.cartoesEntramAnimados
                    }
                  },
                  [
                    _vm.mostrarPerguntasAoGestor
                      ? _c("ManagerQuestions", {
                          staticClass: "mt-3",
                          attrs: {
                            perguntas: _vm.perguntasAoGestor,
                            editavel: _vm.perguntasEditaveis,
                            "respostas-enviadas": _vm.respostasDoFormulario
                          },
                          on: { responder: _vm.onResponderPerguntas }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm.mostrarServicosCitados
                  ? _c("ServicosCitados", {
                      attrs: {
                        "id-conversa": _vm.idConversa,
                        itens: _vm.servicosCitados
                      },
                      on: { "open-service": _vm.onOpenService }
                    })
                  : _vm._e(),
                _vm.mostrarFontes
                  ? _c("ChatMessageFontes", {
                      staticClass: "mt-2",
                      attrs: { sources: _vm.sources }
                    })
                  : _vm._e(),
                _c("ChatMessageFontesWeb", {
                  staticClass: "mt-2",
                  attrs: {
                    persona: _vm.persona,
                    "fontes-persistidas": _vm.message && _vm.message.fontes_web,
                    "ao-vivo": _vm.isStreaming
                  }
                }),
                _c("ChatMessageArtefatos", {
                  staticClass: "mt-2",
                  attrs: {
                    "id-conversa": _vm.idConversa,
                    "id-run": _vm.message && _vm.message.id_run,
                    "ancora-do-run": _vm.ancoraDeArtefatos,
                    "ao-vivo": _vm.isStreaming,
                    "recem-entregue": _vm.criadaAoVivo
                  }
                }),
                _c("ChatMessageFooter", {
                  attrs: {
                    "is-streaming": _vm.trabalhando,
                    "message-id": _vm.messageId,
                    "current-feedback": _vm.currentFeedback,
                    "current-comentario": _vm.currentComentario
                  },
                  on: { feedback: _vm.onFeedback }
                })
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }